import { render, staticRenderFns } from "./UserSetting.vue?vue&type=template&id=218f35d4&scoped=true"
import script from "./UserSetting.vue?vue&type=script&lang=js"
export * from "./UserSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f35d4",
  null
  
)

export default component.exports